import { defineEffect } from '../../../core/effect';
import {
  FLIP_D, FLIP_LAND, flipFaceScript, flipTweak,
} from '../fx/flipOpen';

/**
 * **反転召喚の motion**（Issue #581 の前半 → #628 で分割。指示書 `../direction/flipsummoning.md`）。
 *
 * 盤のカードがその場で表示形式の変更（`pos_change_flip_motion.js`）と同じ「浮いて開く」で裏から表へ返る（`../fx/flipOpen.js`）。
 * 続く召喚バンクは effect（`flipsummoning_effect.js`。整列がこの帯の直後に置くので、effect は待ちを持たない）。
 *
 * ```
 * 0      開く: 盤のカードが少し浮いて、長い辺を軸に開くように裏 → 表へ返る（守備の横 → 攻撃の縦も同じ動きの中で）
 * 400    着地（set_card）
 * 440    終わり（盤のカードに返す）
 * ```
 *
 * core の反転召喚は表示形式をその場で書き換えて `MSG_FLIPSUMMONING` だけを出す（`pos_change` も `move` も来ない）。
 * 帯の頭で盤面（`board`）はもう表攻撃なので、前半は演出の板が前の面（裏）を描いて盤のカードを隠す（`pos_change` と同じやり方）。
 * 前の表示形式は分岐レイヤー（`editorPorts/duelSituations/flipsummoning.js`）が `prevPosition` に付ける。
 */
export default defineEffect({
  situation: 'flipsummoning',
  role: 'motion',
  label: '反転召喚（盤のカードが浮いて開く）',
  color: '#ffb84a',
  duration: () => FLIP_D,
  sounds: () => [{ at: FLIP_LAND - 10, name: 'set_card', gain: 0.8 }],
  tweaks: ({ payload, localMs: t, style }) => {
    if (!payload?.uid || t >= FLIP_D) return {};
    return { [payload.uid]: (h) => flipTweak(h, { t, prev: payload.prevPosition, next: payload.position, style }) };
  },
  layers: [
    {
      id: 'flip',
      label: '開く前の面（裏）',
      space: 'board',
      script: (ctx) => flipFaceScript(ctx, { prev: ctx.payload.prevPosition, next: ctx.payload.position, code: ctx.payload.code }),
    },
  ],
}, 'flipsummoning_motion.js');
